exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".progress-bar-counter__barContainer___3Hd91{position:absolute;margin:0;left:0;top:0;width:100%;background-color:#d2e6ed}.progress-bar-counter__bar___wFhCA{background-color:#00aeef;height:20px}.progress-bar-counter__number___3PkIv{position:absolute;top:0;font-size:16px;line-height:20px;width:50px}.progress-bar-counter__numberLeft___2eG4T{color:#d2e6ed;text-align:right;margin-left:-55px}.progress-bar-counter__numberRight___2jvYZ{color:#00aeef;text-align:left;margin-left:5px}.progress-bar-counter__counter___e3cXe{font-family:Montserrat,sans-serif;font-size:16px;color:#aaa;position:fixed;bottom:20px;right:20px}@media (min-width:768px){.progress-bar-counter__counter___e3cXe{width:auto;bottom:26px;left:auto;right:30px;text-align:right}}", ""]);

// exports
exports.locals = {
	"barContainer": "progress-bar-counter__barContainer___3Hd91",
	"bar": "progress-bar-counter__bar___wFhCA",
	"number": "progress-bar-counter__number___3PkIv",
	"numberLeft": "progress-bar-counter__numberLeft___2eG4T",
	"numberRight": "progress-bar-counter__numberRight___2jvYZ",
	"counter": "progress-bar-counter__counter___e3cXe"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/components/styles/progress-bar-counter.scss
// module id = 1072
// module chunks = 0